@if (isModalOpen) {
  <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div
          class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2/3 sm:p-6"
        >
          <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:text-left sm:ml-4 sm:space-y-4">
              <div class="flex items-center">
                <h3 class="text-base font-semibold text-gray-700" id="modal-title">
                  <strong class="text-amazone-orange">Check</strong> the siblings and diffs of the changed entity in
                  other versions
                </h3>

                <button
                  (click)="closeModal()"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center absolute right-6 cursor-pointer"
                  appAgentAction
                  [agent]="'propagate-changes-modal-' + agentBusinessObject + '-close'"
                  [businessObject]="agentBusinessObject"
                  action="close"
                >
                  <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              <p class="text-sm text-gray-500">
                Set the checkboxes for the siblings you want to update with the same changes as the currently edited
                entity in other versions.
                <span class="size-4 rounded-xs bg-diff-added text-diff-added px-1">NI</span> is indicating that a value
                will be added, <span class="size-4 rounded-xs bg-diff-removed text-diff-removed px-1">NI</span> is
                indicating that a value will be removed.
                <span class="font-semibold">
                  If you cancel the process, no changes will be made. Your changes won't be lost.
                </span>
              </p>
            </div>
          </div>
          <div class="my-4">
            <app-changes-in-other-versions-table
              #changesInOtherVersionsTable
              [propertyUpdateInfo]="propertyUpdateInfo"
              (propertyInfosUpdated)="onPropertyInfosUpdated($event)"
            ></app-changes-in-other-versions-table>
          </div>
          <app-stepper
            (stepChange)="changesInOtherVersionsTable.currentStep = $event"
            (confirm)="confirmChanges()"
            (stepsCanceled)="closeModal()"
            [steps]="steps"
          ></app-stepper>
        </div>
      </div>
    </div>
  </div>
}
